import React from 'react';
import cls from 'classnames';
import makeIconName from '../../utils/makeIconName';
import styles from './index.module.scss';
import { ICONS } from '../../constants/icons';
import makeBodyText from '../../utils/makeText';
const InfoMessage = ({ text, iconName = 'shield', withBorder, noBackIcon, children }) => {
    return (React.createElement("div", { className: cls(styles.resultWrap, {
            [styles.withBorder]: withBorder,
            [styles.noBackIcon]: noBackIcon
        }) },
        React.createElement("div", { className: styles.iconWrap },
            React.createElement("i", { className: `${makeIconName(ICONS.x24[iconName], 'x24')} ${styles.icon} ${styles[iconName]}` })),
        React.createElement("div", { className: styles.text }, text ? React.createElement("p", { className: makeBodyText('S') }, text) : children)));
};
export default InfoMessage;
